import styled from 'styled-components';

// Keeps the alert's radius concentric with the section card's.
export const CompletionBanner = styled.div`
  padding: ${({ theme }) => theme.spacing(1.5)};
`;
